























































import { ContactContext } from '@spa/components/organisms/contact/model/context/contact-context'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { ContactService } from '@spa/services/api/contact'

import { WithConfirmModal } from '@/components/organisms/confirm-modal/with-confirm-modal'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import ContactForm from '@spa/components/organisms/contact/ContactForm.vue'
import AddressConfirmDialog from '@spa/components/organisms/dialog/AddressConfirmDialog.vue'
import { AddressFormState } from '@spa/components/organisms/profile/addressFormState'
import { NameFormState } from '@spa/components/organisms/profile/nameFormState'
import {
  AddressFieldsEnabledState,
  interaction,
  RegisterContactErrorType,
} from '@spa/components/pages/mypage/edit/contact/interaction'
import { convertToRegionName } from '@spa/services/region'

import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { User } from '@spa/store/modules/user/types'

@Component({
  components: {
    SpaErrorDialog,
    ContactForm,
    AddressConfirmDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class NewContact extends Mixins<PluginMixin & WithConfirmModal>(PluginMixin, WithConfirmModal) {
  @Prop({ required: true })
  context: ContactContext

  status: Status = Status.Pending

  nameForm: NameFormState = {
    firstName: '',
    lastName: '',
  }

  addressForm: AddressFormState = {
    zipcode: '',
    prefectureCode: '',
    city: '',
    town: '',
  }

  addressFieldsEnabledState: AddressFieldsEnabledState =
    AddressFieldsEnabledState.init({})

  tel: string = ''

  showModal: boolean = false

  modalMessage: string = ''

  contactService = new ContactService()

  get user(): User {
    return this.$store.state.user.user
  }

  get cancelUrl(): string {
    return this.context.path.editContact
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  get errorOnLoad() {
    return _.get(this.$store.state.contact.error, 'load')
  }

  get addressText(): string {
    const { prefectureCode, city, town } = this.addressForm

    return [convertToRegionName(prefectureCode), city, town].filter(Boolean).join(' ')
  }

  async created() {
    await this.$store.dispatch('user/get')

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  enableAddressFields() {
    this.addressFieldsEnabledState =
      this.addressFieldsEnabledState.searchedAddress()
  }

  async validateAll(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async submit() {
    const isValid = await this.validateAll()
    if (!isValid) {
      this.showInvalidInputError()

      return
    }

    const confirmed = await this.confirm()
    if (!confirmed) return

    this.registerNewAddress()
  }

  async registerNewAddress(): Promise<void> {
    this.status = Status.Loading

    const registerContact = interaction.registerContact({
      contactService: this.contactService,
      invalidInputValidator: this.validateAll,
    })

    const result = await registerContact({
      contactFormState: {
        nameForm: this.nameForm,
        addressForm: this.addressForm,
        tel: this.tel,
      },
    })

    result.fold<void>(
      this.handleSubmissionError,
      async () => {
        await this.$store.dispatch('contact/load', { force: true })

        this.$router.push(this.context.path.editContact)
      }
    )
  }

  handleSubmissionError(errorType: RegisterContactErrorType) {
    switch (errorType) {
      case 'invalid-input':
        this.showInvalidInputError()
        break
      default:
        this.status = Status.Failed
        this.modalMessage = '配送先が登録できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
        this.showModal = true
    }
  }

  showInvalidInputError() {
    this.status = Status.Pending
    this.modalMessage = '入力内容が正しくありません'
    this.showModal = true
  }
}
